import { css } from "@emotion/react";

export const loader = css`
  text-align: center;
`;
